

class ImageGate {
  
 

  constructor(rootElement) {
    this.root = rootElement;
    if (!this.root) {
      return;
    }

   
    this.frames = Array.from(this.root.querySelectorAll('.ig__frame'));
    this.captions = Array.from(this.root.querySelectorAll('.ig__cap'));
    this.fadeMs = parseInt(this.root.dataset.fade, 10) || 400;
    this.smoothScrub = this.root.dataset.scrub === 'true';

    
    if (!this.frames.length) {
      return;
    }

    this.activeIndex = 0;
    this.ticking = false; 

    this.init();
  }

  
  init() {
    
    this.frames[0].classList.add('is-active');
    if (this.captions[0]) {
      this.captions[0].classList.add('is-active');
    }
    
    
    this.onScrollOrResize = this.onScrollOrResize.bind(this);
    this.update = this.update.bind(this);
    
  
    window.addEventListener('scroll', this.onScrollOrResize, { passive: true });
    window.addEventListener('resize', this.onScrollOrResize);
    
    this.initHeaderObserver();
    this.update();
  }


  setCaptions(i0, i1, t) {
    this.captions.forEach((caption, i) => {
      if (i === i0) {
        caption.style.opacity = '1';
        caption.classList.add('is-active');
      } else if (i === i1 && this.smoothScrub) {
        caption.style.opacity = String(Math.max(0, Math.min(1, t)));
        caption.classList.add('is-active');
      } else {
        caption.style.opacity = '0';
        caption.classList.remove('is-active');
      }
    });
  }


  update() {
    const viewportH = window.innerHeight;
    const sectionTop = this.root.offsetTop;
    const totalScrollable = Math.max(1, this.root.offsetHeight - viewportH);
    const traveled = Math.min(Math.max(window.scrollY - sectionTop, 0), totalScrollable);
    const progress = traveled / totalScrollable; // Прогрес від 0 до 1

  
    if (this.smoothScrub && this.frames.length > 1) {
      const segments = this.frames.length;
      const raw = Math.min(segments - 0.0001, progress * segments);
      const seg = Math.floor(raw);
      const t = raw - seg;
      const i0 = Math.min(this.frames.length - 1, seg);
      const i1 = Math.min(this.frames.length - 1, seg + 1);

      this.frames.forEach((el, i) => {
        if (i === i0) {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          el.style.zIndex = '2';
        } else if (i === i1) {
          const y = 100 - (100 * t);
          el.style.opacity = t > 0 ? '1' : '0';
          el.style.transform = `translateY(${y.toFixed(2)}%)`;
          el.style.zIndex = '3';
        } else {
          el.style.opacity = '0';
          el.style.transform = 'translateY(100%)';
          el.style.zIndex = '1';
        }
      });
      this.setCaptions(i0, i1, t);
      this.root.classList.add('ig--scrub');
      return;
    }

  
    const stepIndex = Math.min(this.frames.length - 1, Math.floor(progress * this.frames.length));
    if (stepIndex !== this.activeIndex) {
      const prev = this.frames[this.activeIndex];
      const next = this.frames[stepIndex];

      next.style.opacity = '1';
      next.style.transform = 'translateY(100%)';
      next.style.zIndex = '3';
      void next.offsetHeight;
      next.classList.add('is-active');

      setTimeout(() => {
        if (prev) {
          prev.classList.remove('is-active', 'is-exit');
          prev.setAttribute('style', '');
        }
      }, this.fadeMs + 20);

      if (this.captions[this.activeIndex]) {
        this.captions[this.activeIndex].classList.remove('is-active');
      }
      if (this.captions[stepIndex]) {
        this.captions[stepIndex].classList.add('is-active');
      }
      
      this.activeIndex = stepIndex;
    }
  }


  onScrollOrResize() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }
  

  initHeaderObserver() {
    const header = document.querySelector('.shopify-section-header, .header-wrapper, .site-header, header');
    if (!header) return;
    const observer = new IntersectionObserver((entries) => {
      header.classList.toggle('header--on-hero', entries[0]?.isIntersecting);
    }, { threshold: 0.05 });
    observer.observe(this.root);
  }
}


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-type="image-gate"]').forEach(sectionElement => {
    
    new ImageGate(sectionElement);
  });
});